// extracted by mini-css-extract-plugin
export default {"link":"U2uNPe","root":"S3GIZZ","label":"CQ3ICl"};